<template>
  <div class="login-wrap">
    <div class="lw-hd">HI LIFE</div>
    <div class="lw-info">Retrieve password!</div>
    <el-form :model="forgetForm" class="loginForm">
      <el-form-item prop="phone">
        <el-input class="border-bottom" v-model="forgetForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input class="border-bottom" v-model="forgetForm.code" placeholder="请输入验证码"></el-input>
        <div class="getCode">
          <el-button :loading="isSendSubmit" v-if="isSendTime==60" @click="getCode" type="text">获取验证码</el-button>
          <span v-else>已发送({{isSendTime}}s)</span>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="loginBtn">下一步</el-button>
        <div class="forget"><a href="javascript:;" @click="$router.replace({path:'/assist/login'})">返回登录</a></div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data () {
      return {
        forgetForm: {},
        isSendTime: 60,
        isSendSubmit: false
      }
    },
    methods: {
      getCode () {
        let phone = this.forgetForm.phone
        if (phone && /^1[23456789]\d{9}$/.test(phone)) {
          this.isSendSubmit = true
          this.$api.getCode({phone: phone, purpose: 1}, () => {
            let sub = () => {
              if (this.isSendTime > 0) {
                setTimeout(() => {
                  this.isSendTime--
                  sub()
                }, 1000)
              } else {
                this.isSendTime = 60
                this.isSendSubmit = false
              }
            }
            sub()
          }, () => {
            this.isSendSubmit = false
          })
        } else {
          this.$message.warning('请输入正确的手机号码')
        }
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .login-wrap {
    width: 300px;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 100px;
  }

  .lw-hd {
    text-align: center;
    font-size: 30px;
    color: #ffb41d;
    font-family: -webkit-pictograph;
    line-height: 35px;
  }

  .lw-info {
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 18px;
  }

  .loginForm {
    padding-top: 40px;
  }

  .getCode {
    position: absolute;
    width: 80px;
    height: 34px;
    top: 0;
    right: 0;
    color: #999;

    .getCodeBtn {
      color: #ffb41d;
    }
  }

  .loginBtn {
    width: 100%;
  }

  .forget {
    text-align: right;

    a {
      color: #999;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/assist/forget/index.vue